<script>
  export let value = '';
  export let placeholder = '';
  export let error = '';
  export let label = '';
  export let id = '';
  export let rows = 4;
  export let disabled = false;
  export let fullWidth = true;

  function handleInput(event) {
    value = event.target.value;
  }
</script>

<div class="{fullWidth ? 'w-full' : ''}">
  {#if label}
    <label for={id} class="block text-sm font-medium mb-2" style="font-family: var(--font-body); color: var(--fg);">
      {label}
    </label>
  {/if}

  <textarea
    {id}
    {placeholder}
    {disabled}
    {rows}
    {value}
    on:input={handleInput}
    class="textarea-field {fullWidth ? 'w-full' : ''} {error ? 'textarea-error' : ''} {disabled ? 'textarea-disabled' : ''}"
    on:blur
    on:focus
  />

  {#if error}
    <p class="mt-2 text-sm" style="color: #DC2626;" role="alert">
      {error}
    </p>
  {/if}
</div>

<style>
  .textarea-field {
    padding: 12px 16px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background: var(--bg-raised);
    color: var(--fg);
    font-family: monospace;
    font-size: 0.875rem;
    transition: all var(--dur-med) var(--ease-out);
    resize: none;
  }

  .textarea-field::placeholder {
    color: var(--fg-subtle);
  }

  .textarea-field:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(30, 90, 126, 0.1);
  }

  .textarea-field.textarea-error {
    border-color: #DC2626;
  }

  .textarea-field.textarea-error:focus {
    border-color: #DC2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  }

  .textarea-field.textarea-disabled {
    background: var(--bg-sunken);
    cursor: not-allowed;
    opacity: 0.6;
  }
</style>
